import { createContextualCan } from '@casl/react';
import { createContext } from 'react';

export const AbilityContext = createContext({});
export default createContextualCan(AbilityContext.Consumer);
